import React from "react";
import { Link } from "react-router-dom";
import { DOMAINS, OBSERVATIONS } from "@/data/content";

export const AreasOfStudy = () => {
  // Counts per domain
  const counts = DOMAINS.map((d) => ({
    ...d,
    count: OBSERVATIONS.filter((o) => o.domain === d.slug).length,
  }));

  return (
    <section data-testid="home-areas-of-study" className="bg-ink-base py-24 md:py-36 border-t border-ink-line">
      <div className="container-edge">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 mb-14 md:mb-20">
          <div className="lg:col-span-5">
            <p className="eyebrow-gold mb-5">Areas of Inquiry</p>
            <h2 className="display-serif text-3xl md:text-5xl text-paper-primary text-balance">
              Eleven territories that keep returning the work.
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7">
            <p className="font-serif text-lg md:text-xl text-paper-secondary leading-relaxed text-pretty">
              These are not categories. They are the places this work tends to find itself when honest.
              Filtering is available. Wandering is encouraged.
            </p>
          </div>
        </div>

        <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {counts.map((d, idx) => (
            <li key={d.slug} className={`group relative border-t border-ink-line ${idx % 4 !== 3 ? "lg:border-r-0 xl:border-r" : ""}`}>
              <Link
                to={`/thinking?domain=${d.slug}`}
                data-testid={`area-${d.slug}`}
                className="block py-8 md:py-10 px-4 hover:bg-ink-surface/40 transition-colors duration-300"
              >
                <div className="flex items-baseline justify-between gap-3">
                  <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-paper-mute">{d.number}</p>
                  <p className="font-mono text-[10px] text-paper-mute">
                    {d.count > 0 ? `${d.count} entr${d.count === 1 ? "y" : "ies"}` : ","}
                  </p>
                </div>
                <p className="mt-4 font-serif text-2xl md:text-3xl text-paper-primary group-hover:text-gold-warm transition-colors duration-300">
                  {d.name}
                </p>
                <div className="mt-6 inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.24em] text-paper-tertiary group-hover:text-paper-primary transition-colors duration-300">
                  <span>Explore</span>
                  <span className="transition-transform duration-300 group-hover:translate-x-1">→</span>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default AreasOfStudy;
